var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag, TextAreaTag } from '../../Utils/AtomicTag';
import { OptionList } from './OptionList';
import { Option } from './Option';
import { getLastMeasureIndex, replaceWithMeasure, omit, validateSearch } from './utils';
import { toArray } from '../../Utils/react';
import { KeyCode } from '../../Utils/keyCode';
var Mentions = /** @class */ (function (_super) {
    __extends(Mentions, _super);
    function Mentions(props) {
        var _this = _super.call(this, props) || this;
        _this.container = React.createRef();
        _this.setMeasureRef = React.createRef();
        _this.textareaRef = React.createRef();
        _this.onFocus = function () {
            _this.setState({
                isFocus: true,
            });
            _this.props.onFocus();
        };
        _this.onKeyUp = function (e) {
            var _a = _this.props, prefix = _a.prefix, onSearch = _a.onSearch;
            var target = e.target, key = e.key, which = e.which;
            var value = target.value, selectionStart = target.selectionStart;
            var _b = _this.state, prevMeasureText = _b.measureText, measuring = _b.measuring;
            // 获取光标前的数据
            var selectionStartText = value.slice(0, selectionStart);
            var _c = getLastMeasureIndex(selectionStartText, prefix), measureIndex = _c.location, measurePrefix = _c.prefix;
            // 键盘操作会与弹框选择键盘操作冲突
            if ([KeyCode.ESC, KeyCode.UP, KeyCode.DOWN, KeyCode.ENTER].indexOf(which) !== -1) {
                return;
            }
            // 查询到关键词
            if (measureIndex !== -1) {
                var measureText = selectionStartText.slice(measureIndex + measurePrefix.length);
                var mergeOptions = !!_this.getOptions(measureText).length;
                var validateMeasure = validateSearch(measureText, _this.props);
                if (validateMeasure) {
                    if (key === measurePrefix ||
                        key === 'Shift' ||
                        measuring ||
                        (prevMeasureText !== measureText && mergeOptions)) {
                        _this.startMeasure(measureIndex, measureText, measurePrefix);
                    }
                }
                else {
                    _this.stopMeasure();
                }
                if (validateMeasure) {
                    onSearch(measureText, measurePrefix);
                }
            }
            else {
                _this.stopMeasure();
            }
        };
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, customValue = _a.value;
            var value = e.target.value;
            !customValue &&
                _this.setState({
                    inputValue: value,
                });
            onChange(value, e);
        };
        _this.onBlur = function () {
            _this.props.onBlur();
            _this.setState({
                isFocus: false,
            });
            _this.stopMeasure();
        };
        // 开始匹配
        _this.startMeasure = function (measureLocation, measureText, measurePrefix) {
            _this.setState({
                measureLocation: measureLocation,
                measurePrefix: measurePrefix,
                open: true,
                measureText: measureText,
            }, function () {
                _this.setState({
                    measuring: true,
                });
            });
        };
        // 停止匹配
        _this.stopMeasure = function (callback) {
            _this.setState({
                open: false,
                measuring: false,
                measureLocation: 0,
                measureText: '',
            }, callback);
        };
        // 获取提示列表
        _this.getOptions = function (mearsureText) {
            var mergeMearsureText = mearsureText || _this.state.measureText || '';
            var _a = _this.props, children = _a.children, filterOption = _a.filterOption;
            var list = toArray(children)
                .map(function (_a) {
                var props = _a.props, key = _a.key;
                return (__assign(__assign({}, props), { key: (key || props.value) }));
            })
                .filter(function (option) {
                if (filterOption === false) {
                    return true;
                }
                return filterOption(mergeMearsureText, option);
            });
            return list;
        };
        /** 类目选择 */
        _this.selectOption = function (e, option) {
            // console.log('选中当前类目', option)
            var _a = _this.state, inputValue = _a.inputValue, measureLocation = _a.measureLocation, measurePrefix = _a.measurePrefix;
            var _b = _this.props, split = _b.split, onSelect = _b.onSelect, onChange = _b.onChange;
            var _c = option.value, mentionValue = _c === void 0 ? '' : _c;
            var _d = replaceWithMeasure(inputValue, {
                measureLocation: measureLocation,
                targetText: mentionValue,
                prefix: measurePrefix,
                selectionStart: _this.textareaRef.current.selectionStart,
                split: split,
            }), text = _d.text, selectionLocation = _d.selectionLocation;
            _this.setState({
                inputValue: text,
            });
            // 赋值完成之后，设置光标的位置
            _this.stopMeasure(function () {
                _this.textareaRef.current.setSelectionRange(selectionLocation, selectionLocation);
            });
            onChange(text, e);
            onSelect(option.value, option);
        };
        _this.state = {
            isFocus: false,
            open: false,
            inputValue: _this.props.value || _this.props.defaultValue || '',
            measuring: false,
            measureLocation: 0,
            measurePrefix: '',
            measureText: '',
        };
        return _this;
    }
    Mentions.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== undefined) {
            this.setState({
                inputValue: nextProps.value,
            });
        }
    };
    Mentions.prototype.renderPrefix = function () {
        return React.createElement(SpanTag, null, this.state.measurePrefix);
    };
    Mentions.prototype.renderPrevPrefix = function () {
        var _a = this.state, inputValue = _a.inputValue, measureLocation = _a.measureLocation;
        var prevContent = inputValue
            .slice(0, measureLocation)
            .replace(/\n|\r\n/g, '<br>')
            .replace(/\s/g, '&nbsp;');
        return prevContent ? React.createElement("i", { dangerouslySetInnerHTML: { __html: prevContent } }) : '';
    };
    Mentions.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, value = _a.value, loading = _a.loading, notFoundContent = _a.notFoundContent, onSearch = _a.onSearch, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onSelect = _a.onSelect, filterOption = _a.filterOption, split = _a.split, placement = _a.placement, prefix = _a.prefix, rows = _a.rows, rest = __rest(_a, ["placeholder", "value", "loading", "notFoundContent", "onSearch", "onChange", "onBlur", "onFocus", "onSelect", "filterOption", "split", "placement", "prefix", "rows"]);
        var textareaProps = omit(rest, 'style', 'className', 'ref', 'defaultValue', 'children');
        var _b = this.state, isFocus = _b.isFocus, inputValue = _b.inputValue, open = _b.open, measureLocation = _b.measureLocation, measurePrefix = _b.measurePrefix, measuring = _b.measuring;
        var mentionCls = [
            'relative',
            'min-w-px-160',
            'border',
            'border-solid',
            'relative',
            'inline-block',
            'rounded-sm',
            'h-auto',
            'align-bottom',
            'rounded',
            isFocus ? 'border-brand-600' : null,
            isFocus ? 'shadow-input' : null,
            'hover:border-brand-600',
        ];
        var textareaCls = [
            'w-full',
            'px-px-12',
            'py-px-4',
            'border-none',
            'rounded',
            'align-top',
        ];
        var measureCls = [
            'absolute',
            'inset-0',
            'px-px-12',
            'py-px-4',
            'text-transparent',
        ];
        var options = this.getOptions() || [];
        return (React.createElement(DivTag, __assign({ name: Mentions.NAME, atomics: mentionCls, ref: this.container }, rest),
            React.createElement(TextAreaTag, __assign({ atomics: textareaCls, value: inputValue, rows: rows < 1 ? 1 : rows, autoPrefixedClassName: "mentions-textarea", placeholder: placeholder, onFocus: this.onFocus, onKeyUp: this.onKeyUp, onChange: this.onChange, onBlur: this.onBlur, ref: this.textareaRef }, textareaProps)),
            open && (React.createElement(DivTag, { ref: this.setMeasureRef, atomics: measureCls, autoPrefixedClassName: "mentions-option-list" },
                this.renderPrevPrefix(),
                this.renderPrefix(),
                inputValue.slice(measureLocation + measurePrefix.length),
                React.createElement(OptionList, { options: options, open: measuring, loading: loading, container: this.container, textareaRef: this.textareaRef, measureRef: this.setMeasureRef, notFoundContent: notFoundContent, placement: placement, selectOption: function (e, option) {
                        return _this.selectOption(e, option);
                    } })))));
    };
    Mentions.Option = Option;
    Mentions.defaultProps = defaultProps;
    Mentions.NAME = 'mentions';
    Mentions.displayName = 'Mentions';
    return Mentions;
}(PureComponent));
export { Mentions };
